"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.store = void 0;
/* eslint-disable @typescript-eslint/no-unsafe-assignment */
var toolkit_1 = require("@reduxjs/toolkit");
var RootReducer_1 = require("./RootReducer");
exports.store = (0, toolkit_1.configureStore)({
    reducer: RootReducer_1.rootReducer,
    devTools: {
        name: 'predictiveModelUI',
    },
    middleware: function (getDefaultMiddleware) {
        return getDefaultMiddleware({
            serializableCheck: {
                // Ignore these action types
                ignoredActions: ['subspace/updateTrainingProgressStatus'],
            },
        });
    },
});
//# sourceMappingURL=Store.js.map